import { useEffect } from "react";

// Intercept in-page hash links (href="#section") and smooth-scroll to the target
// WITHOUT pushing "#section" into the URL. External/mailto/tel links are untouched.
export function useSmoothAnchors() {
  useEffect(() => {
    const onClick = (event) => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href").slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth" });
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
}